import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Peter Noble
 * id 51584101-DF6C-49FF-8ACB-13F7064DEE89
 * name shield-alert-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-alert-outline.svg
 * tags
 * - Alert / Error 
 */
export const ShieldAlertOutlineIcon = createSvgIcon(<><path d="M21,11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11M12,21C15.75,20 19,15.54 19,11.22V6.3L12,3.18L5,6.3V11.22C5,15.54 8.25,20 12,21M11,7H13V13H11V7M11,15H13V17H11V15Z" /></>, 'ShieldAlertOutlineIcon');
export default ShieldAlertOutlineIcon